<div class="loader-placeholder-wrapper">
  <span class="card-header">{{ cardHeader }}</span>
</div>
